<div class="feature">
  <h5 class="font-16 fw-bold text-center text-uppercase text-black">{{ 'feature.title' | translate }}</h5>
  <div class="marquee">
    <div class="track">
      <div class="content">
        @for (item of items; track item) {
          <img loading="lazy" src="{{ item.img }}" alt="featured-img" />
        }
      </div>
    </div>
    <div class="track">
      <div class="content">
        @for (item of items; track item) {
          <img loading="lazy" src="{{ item.img }}" alt="featured-img" />
        }
      </div>
    </div>
  </div>
</div>
